import React from 'react'

import Direcao from '../../../../assets/logos/direcao-square.png'
import Progress from '../../../../components/Progress'
import {
  Container,
  CourseTitle,
  ImageWrapper,
  ProgressWrapper,
  ContentWrapper,
  UpseelWrapper,
  BuyModule,
} from './styles'

import { BsArrowLeftShort, BsCart } from 'react-icons/bs'
import history from '../../../../services/history'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'

interface CourseBannerProps {
  course: any
}

const CourseBanner: React.FC<CourseBannerProps> = ({ course }) => {
  const { recentPath } = useSelector((state: RootState) => state.recentView)

  return (
    course?.name && (
      <Container>
        <button onClick={() => history.push(recentPath)}>
          <BsArrowLeftShort size={25} /> Voltar
        </button>
        <ContentWrapper>
          <ImageWrapper>
            <img src={course?.icon || Direcao} alt={course?.name} />
          </ImageWrapper>
          <CourseTitle>
            <h2>{course?.name}</h2>
            <p>
              {course?.name}
              {course?.notice ? (
                <a
                  style={{ marginLeft: '10px' }}
                  target="_blank"
                  rel="noreferrer"
                  href={course?.notice}
                >
                  ver edital
                </a>
              ) : (
                ''
              )}
            </p>
          </CourseTitle>
        </ContentWrapper>

        {(course?.isFreemium ||
          course?.children.filter((c) => c?.available?.type === 'sell').length > 1) && (
          <UpseelWrapper>
            <p>
              Na compra do <strong>curso completo</strong>, você economiza e tem acesso a todos os
              módulos
              {course?.features?.infiniteGuarantee ? ` e ao programa de Garantia Infinita` : ''}.
            </p>
            <BuyModule href={course.permanentLink} target="_blank">
              <BsCart size={18} />
              Comprar
            </BuyModule>
          </UpseelWrapper>
        )}

        {['Padrao', 'Discursivacomcorreção', 'TurmaDosFeras'].includes(course?.contentType) ? (
          <ProgressWrapper>
            <span>Progresso no curso</span>
            <Progress percentage={course?.progress || 0} page="courseBanner" />
          </ProgressWrapper>
        ) : (
          <div />
        )}
      </Container>
    )
  )
}

export default CourseBanner
